import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import MyQueryRenderer from "../MyQueryRenderer";
import moment from 'moment';
import ReactTable from 'react-table'; /* for the report tables */
import { csvFormat } from 'd3-dsv';
import 'react-table/react-table.css';

import { requestProfilesForIdentities } from 'APP_ROOT/data/identities/actions';
import ProfileImage from 'APP_ROOT/components/ProfileImage';
import ErrorMessage from 'APP_ROOT/components/ErrorMessage';

import MaintenanceMessage from '../MaintenanceMessage';

function toHHMMSS(sec_num) {

    var hours   = Math.floor(sec_num / 3600);
    var minutes = sec_num % 3600;
    var seconds = Math.floor(minutes % 60);
    minutes = Math.floor(minutes / 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    if(hours === 0)
        return minutes+':'+seconds;
    else
        return hours+':'+minutes+':'+seconds;
}

function getWeeksBetweenDates (start, end) {

    var now = start.clone(), dates = [];

    while (now.isSameOrBefore(end)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(7, 'days');
    }

    dates.push(end.format('YYYY-MM-DD'));

    return dates;

}

function getRawData(resultSet)
{
    var rows = [];

    if('rawData' in resultSet)
    {
        rows = resultSet.rawData();
    }
    else
    {
        for(var i = 0; ; i++)
        {
            if(resultSet.hasOwnProperty(i.toString()))
            {
                rows = rows.concat(resultSet[i.toString()].rawData());
                continue;
            }
            else
            {
                break;
            }
        }
    }
    return rows;
}

function exportFormatEndTime(startTime, endTime)
{
    var result = formatEndTime(startTime, endTime)

    if(Array.isArray(result))
        return result[0] + " (" + result[2] + ")";
    else
        return result;
}


class ReportsSection extends React.PureComponent {

    render() {

        var myLastQuery = {
                    "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                    "measures": [
                        "FactGeofenceState.durationInSeconds",
                    ],
                    "timeDimensions": [
                        {
                            "dimension": "FactGeofenceState.startTime",
                            "dateRange": [
                                moment(this.props.selectedDateRange[0]).format('YYYY-MM-DD'),
                                moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD'),
                            ]
                        }
                    ],
                    "dimensions": [
                        "DimGeofence.name",
                        "DimGeofence.description",
                        "DimRaven.uuid",
                        "DimDriver.name",
                        "DimDriver.identityId",
                        "DimVehicle.name",
                        "FactGeofenceState.startTime",
                        "FactGeofenceState.endTime",
                        "DimCard.cardId",
                        "DimCard.type",
                    ],
                    "order": {
                        "DimRaven.uuid": 'asc',
                        'DimCard.cardId': 'asc',
                        'FactGeofenceState.startTime': 'asc',
                    },
                };

        var queries = [];

        var weeks = getWeeksBetweenDates(moment(this.props.selectedDateRange[0]),
                moment(this.props.selectedDateRange[1]));

        myLastQuery.limit = 9000;

        for(var i = 0; i < weeks.length; i++)
        {
            let minday = ""+weeks[i]+"T00:00:00";
            let maxday = ""+weeks[i]+"T23:59:59";
            if(i < (weeks.length - 1))
            {
                maxday = ""+weeks[i+1]+"T00:00:00";
            }

            myLastQuery.timeDimensions = [
                            {
                                "dimension": "FactGeofenceState.startTime",
                                "dateRange": [ minday, maxday ]
                            }
                ];


            queries.push({...myLastQuery});

        }


        return (
            <MyQueryRenderer
                user={this.props.user}
                cubejsApi={this.props.cubejsApi}
                queries={queries}
                render={this.renderChart(myLastQuery, ConnectedReportTable, this.props)}
            />
        );
    }

    renderChart = (myLastQuery, Component, props) => ({ resultSet, error, loadingState, ...otherProps }) => {
        if (error) {
            return this.renderError(error);
        } else if(resultSet) {
            return (
                <Component
                    {...otherProps}
                    stage={props.user.stage}
                    groupBy={props.groupBy}
                    unitOfMeasure={props.unitOfMeasure}
                    resultSet={resultSet}
                    loadingState={loadingState}
                    limitTo={props.limitTo}
                    limitToFilteredResources={props.limitToFilteredResources}
                />
            );
        } else {
            return <div>{strings.loading}</div>;
        }
    };

    renderError = error => {
        if(error.message && error.message.match(/maintenance/i)) {
            return <MaintenanceMessage message={error.message} />;
        } else {
            return <ErrorMessage error={error} />;
        }
    }
}

function formatEndTime(startTime, endTime)
{
    var endFormated = endTime.format("hh:mm:ss a");
    if(startTime.format("MMM Do YYYY") == endTime.format("MMM Do YYYY"))
    {
        return endFormated;
    }

    var days = endTime.diff(startTime, 'days') + 1 ;

    var daysText;

    daysText = "+" + days + " " + (days === 1 ? strings.day : strings.days);


    return [
        endFormated,
        <br/>,
        daysText
    ];
}


// A HOC that wraps a value in a link to /en/stats/history
const HistoryLinkCell = cardIdFieldName => ({ value, original }) => (
    <a
        href={original._historyUrlOverride || `/${getCurrentLocale()}/stats/history/${original['DimRaven.uuid']}/${original[cardIdFieldName]}`}
        target='_blank'
        rel='noopener noreferrer'
    >
        {value}
    </a>
);

// A HOC that places a timestamp value into the provided WrapperComponent
const TimeCell = WrapperComponent => ({value, ...rest}) => (
    <WrapperComponent
        {...rest}
        value={value}
    />
);

// A HOC that places a timestamp value into the provided WrapperComponent
const EndTimeCell = WrapperComponent => ({value, ...rest}) => (
    <WrapperComponent
        {...rest}
        value=<div title= {moment.utc(value).local().format("LLLL")}> { formatEndTime( moment.utc(rest.original['FactGeofenceState.startTime']).local(), moment.utc(value).local()) } </div>
    />
);

class ReportTable extends React.PureComponent {

    componentDidMount() {
        this.fetchIdentities();
    }

    componentDidUpdate() {
        this.fetchIdentities();
    }

    fetchIdentities = () => {
        const identityIds = new Set();
        const rows = getRawData(this.props.resultSet);
        rows.forEach(r => {
            if (r['DimDriver.identityId']) identityIds.add(r['DimDriver.identityId']);
        });
        this.props.dispatch(requestProfilesForIdentities(this.props.stage, Array.from(identityIds)));
    }

    getDimensionColumn = (name, field, overrides = {}) => {
        return ({
            Header: name,
            Placeholder: strings.formatString(strings.reports_header_filter_x_names, name.toLowerCase()),
            accessor: d => d[field],
            id: field,
            ...overrides
        });
    };

    getIdentityId = row => {
        if (row['DimDriver.identityId']) {
            return row['DimDriver.identityId'];
        }
        if (row._subRows && row._subRows[0]) {
            return this.getIdentityId(row._subRows[0]);
        }
        return null;
    }

    generateExportURI = (columns, rawRows) => {
        const outputRows = rawRows.map(row => {
            const outRow = {};
            columns.forEach(col => {
                if((col.show || col.show === undefined || col.export)
                    && (col.export || col.export === undefined)) {
                    if(col.exportAccessor) {
                        outRow[col.Header] = (typeof col.exportAccessor === 'string' ? row[col.exportAccessor] : col.exportAccessor(row));
                    } else {
                        outRow[col.Header] = (typeof col.accessor === 'string' ? row[col.accessor] : col.accessor(row));
                    }
                }
            });
            return outRow;
        });
        const BOM='\uFEFF';
        return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(csvFormat(outputRows))}`;
    }

    render() {
        const { resultSet, stage } = this.props;

        // Have a sidelong lookup for geofence descriptions
        // takes the most recent description in the reduce(...) below
        var geofenceDescriptions = {};

        var pivots = [];
        var dims = [];
        var sort = [];
        const groupByIncludesDriver = this.props.groupBy && this.props.groupBy.includes('driver');

        pivots.push('DimGeofence.name');
        dims.push(this.getDimensionColumn(strings.reports_header_geofence,'DimGeofence.name', {
                PivotValue: (value) => {
                    return (
                    <span title={geofenceDescriptions[value.row['DimGeofence.name']]} >
                      {value.row['DimGeofence.name']}
                    </span>
                    );
                },

            }));
        sort.push({id:'DimGeofence.name', desc: false});

        if(this.props.groupBy === "vehicle")
        {
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            sort.push({id:'DimVehicle.name', desc: false});
        }
        else if(this.props.groupBy === "driver")
        {
            pivots.push('DimDriver.name');
            dims.push(this.getDimensionColumn(strings.reports_header_driver,'DimDriver.name', {
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    // TODO: no need to replace name conditionally with strings.unknown here if we group by identityId
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            imgSize='96px'
                            expander={true}
                            expanderClass={classes}
                        />
                    );
                },
            }));
            sort.push({id:'DimDriver.name', desc: false});
        }
        else if(this.props.groupBy === "vehicle,driver")
        {
            pivots.push('DimVehicle.name');
            pivots.push('DimDriver.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            dims.push(this.getDimensionColumn(strings.reports_header_driver,'DimDriver.name', {
                className: 'aggregate-list',
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            imgSize='64px'
                            expander={true}
                            expanderClass={classes}
                        />
                    );
                },
                aggregate: vals => {
                    /* TODO: using custom aggregate to sanitize strings.unknowns, but it would be nice if this could be avoided */
                    var myset = new Set();

                    if(vals.length <= 0)
                    {
                        return myset;
                    }

                    vals.forEach(x => {

                        if(typeof x === 'string')
                        {
                            myset.add(x);
                        }
                        else
                        {
                            x.forEach(y => {
                                myset.add(y);
                            });
                        }

                    });

                    return Array.from(myset);
                },
                Aggregated: row => {

                    return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                        <span>
                            {row.value.map((value, index) => {
                                return  <span key={index}>
                                    {value}
                                    {index === row.value.length - 1 ? "" : ","}
                                </span>
                            })}
                        </span>
                    )
                }
            }));
            sort.push({id:'DimVehicle.name', desc: false});
            sort.push({id:'DimDriver.name', desc: false});
        }
        else if(this.props.groupBy === "driver,vehicle")
        {
            pivots.push('DimDriver.name');
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_driver,'DimDriver.name', {
                className: 'aggregate-list',
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            expander={true}
                            expanderClass={classes}
                            imgSize='96px'
                        />
                    );
                },
            }));
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name', {
                className: 'aggregate-list',
                aggregate: (vals, rows) => {
                    /* TODO: using custom aggregate to sanitize strings.unknowns, but it would be nice if this could be avoided */
                    var myset = new Set();

                    if(vals.length <= 0)
                    {
                        return myset;
                    }

                    vals.forEach(x => {

                        if(typeof x === 'string')
                        {
                            myset.add(x);
                        }
                        else
                        {
                            x.forEach(y => {
                                myset.add(y);
                            });
                        }

                    });

                    return Array.from(myset);
                },
                Aggregated: row => {

                    return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                        <span>
                            {row.value.map((value, index) => {
                                return  <span key={index}>
                                    {value}
                                    {index === row.value.length - 1 ? "" : ","}
                                </span>
                            })}
                        </span>
                    )
                }
            }));
            sort.push({id:'DimDriver.name', desc: false});
            sort.push({id:'DimVehicle.name', desc: false});
        }
        else
        {
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            sort.push({id:'DimVehicle.name', desc: false});
        }

        const columns = dims.concat([
            {
                accessor: d => d['DimDriver.identityId'],
                id: 'DimDriver.identityId',
                show: false,
            },
            {
                Header: strings.reports_header_date,
                className: 'aggregate-list',
                accessor: d => d['FactGeofenceState.startTime'] ? moment.utc(d['FactGeofenceState.startTime']).local().format("MMM Do YYYY") : "-",
                sortMethod: d => d['FactGeofenceState.startTime'] ? moment.utc(d['FactGeofenceState.startTime']).local() : 0,
                id: 'FactGeofenceState.startTime',
                PivotValue: x => <div> { x.value } ({ x.subRows.length })</div>,
                aggregate: vals => {
                    if(vals.length <= 0)
                    {
                        return null;
                    }
                    var min = moment(vals[0], "MMM Do YYYY");
                    var max = min;
                    vals.forEach(x => {
                        if(Array.isArray(x))
                        {
                            var val1 = moment(x[0], "MMM Do YYYY");
                            var val2 = moment(x[1], "MMM Do YYYY");
                            if(min > val1) min = val1;
                            if(max < val2) max = val2;
                        }
                        else
                        {
                            var val = moment(x, "MMM Do YYYY");
                            if(min > val) min = val;
                            if(max < val) max = val;
                        }

                    });
                    if(min === max)
                        return min.local().format("MMM Do YYYY");

                    return [min.local().format("MMM Do YYYY"), max.local().format("MMM Do YYYY")];
                },
                Aggregated: (x) => {
                    /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" above renders using <span> since we don't custom aggregate */
                    if(typeof x.value === "string")
                        return <span>{x.value}</span>

                    return x.value && x.value.length === 2 ? (
                        <span>
                            <span>{x.value[0]} - </span>
                            <span>{x.value[1]}</span>
                        </span>
                    ) : (
                        <span>
                            -
                        </span>
                    );
                },
                filterable: false,
            },
            {
                Header: strings.reports_header_geofence_enter,
                accessor: d => moment.utc(d['FactGeofenceState.startTime']).local().format("hh:mm:ss a"),
                id: 'starttime',
                Aggregated: () => null,
                Cell: TimeCell(HistoryLinkCell('enterCardId')),
                filterable: false,
            },
            {
                Header: strings.reports_header_geofence_exit,
                accessor: d => d['FactGeofenceState.endTime'],
                exportAccessor: d => exportFormatEndTime(moment.utc(d['FactGeofenceState.startTime']).local(), moment.utc(d['FactGeofenceState.endTime']).local()),
                id: 'endtime',
                Aggregated: () => null,
                Cell: EndTimeCell(HistoryLinkCell('exitCardId')),
                filterable: false,
            },
            {
                Header: strings.reports_header_geofence_time_inside,
                Cell: d => (<div>{ toHHMMSS(d.value) }</div>),
                accessor: d => d['FactGeofenceState.durationInSeconds'],
                exportAccessor: d => toHHMMSS(d['FactGeofenceState.durationInSeconds']),
                id: 'FactGeofenceState.durationInSeconds',
                aggregate: vals => vals.reduce((it, acc) => acc + it, 0),
                Aggregated: d => (<div>{ toHHMMSS(d.value) }</div>),
                filterable: false,
            },
        ]);

        // limit to ravens that are included in the selected tags
        const rows = this.props.limitToFilteredResources(getRawData(resultSet), this.props.limitTo);

        // Roll up the rows (geofence visits) into aggregate records
        // If contiguous driving, parked then driving segments/cards are all in one geofence, then
        // amalgamate it into one record
        // obj holds all cards in a 'data' variable, keyed on card id
        const cards = rows.reduce( (obj, row) => {
            // We are rolling up the records in order.
            // Look in the current rollups to see if we have an end time that matches
            // our start time

            var recordindex = `${row['DimRaven.uuid']}.${row['DimGeofence.name']}`;

            var records = obj.data[recordindex];

            // Create an initial blank record which may be thrown away
            // if we find a current one
            // Set duration in seconds to 0 as it will be added below
            var curcard = {
                ...row,
                'FactGeofenceState.durationInSeconds': 0,
                enterCardId: row['DimCard.cardId'],
                exitCardId: row['DimCard.cardId'],
                segmentcount: 1
            };

            if(!records)
            {
                if(groupByIncludesDriver)
                {
                    // Skip any cards that aren't 'trip' when removing parked
                    if(row['DimCard.type'] !== 'trip') return obj;
                }

                // Add empty array for this record index
                obj.data[recordindex] = [];
                obj.data[recordindex].push(curcard);

            }
            else
            {
                // There is at least one record for this Raven in this geofence
                // See if we are going to tack on this data to an existing record
                const existing = records.find(it => {
                    return (it["FactGeofenceState.endTime"] === row["FactGeofenceState.startTime"] ||
                            it["FactGeofenceState.startTime"] === row["FactGeofenceState.endTime"])
                        && (!groupByIncludesDriver
                            || row["DimCard.type"] === 'parked'
                            || it["DimDriver.identityId"] === row["DimDriver.identityId"]);
                });


                if (existing) {
                    curcard = existing;
                } else {
                    // Add the empty record in, since we didn't find one
                    records.push(curcard);
                }
            }

            if(row['DimVehicle.name'] === null)
            {
                console.error('DimVehicle.name is null. This is NOT supposed to happen.');
                row['DimVehicle.name'] = strings.unknown;
            }

            curcard['FactGeofenceState.durationInSeconds'] += row['FactGeofenceState.durationInSeconds'];

            // already multi driver?
            if(!curcard['DimDriver.identityId'])
            {
                // If nothing is recognized on this segment, but a previous segment had an identity, use that
                curcard['DimDriver.identityId'] = row['DimDriver.identityId'];
                if(!curcard['DimDriver.name'])
                {
                    // If we don't have an identity or name, copy both.
                    curcard['DimDriver.name'] = row['DimDriver.name'];
                }
            }

            if(row['DimGeofence.description'])
                geofenceDescriptions[row['DimGeofence.name']] = row['DimGeofence.description']; 

            if(moment(curcard['FactGeofenceState.startTime']) > moment(row['FactGeofenceState.startTime']))
            {
                curcard['FactGeofenceState.startTime'] = row['FactGeofenceState.startTime'];
                curcard.enterCardId = row['DimCard.cardId'];
            }
            if(moment(curcard['FactGeofenceState.endTime']) < moment(row['FactGeofenceState.endTime']))
            {
                curcard['FactGeofenceState.endTime'] = row['FactGeofenceState.endTime'];
                curcard.exitCardId = row['DimCard.cardId'];
            }
            curcard['segmentcount'] += 1;

            // curcard is already in the obj array, so we should be done now

            // reverse lookup set
            obj.indexes.add(recordindex);

            if (row["DimDriver.identityId"]) obj.identityIds.add(row["DimDriver.identityId"]);

            return obj;

        }, { data: {}, indexes: new Set(), identityIds: new Set() });

        const finalcards = [];
        cards.indexes.forEach( (it) => {
            cards.data[it].forEach( (curcard) => {
                // TODO: group by identityId only, not name. let name just be strings.unknown
                if(!curcard['DimDriver.name'] && curcard['DimDriver.identityId'])
                {
                    curcard['DimDriver.name'] = strings.unknown + curcard['DimDriver.identityId'];
                }
                if(!curcard['DimDriver.name'])
                {
                    curcard['DimDriver.name'] = strings.unknown;
                }

                finalcards.push(curcard);
            });
        });

        if(!cards || cards.length <= 0)
        {
            return (
                <div>
                    <h4>{strings.reports_no_data_for_selected_time_period}</h4>
                </div>
            );
        }

        if (this.props.historyUrlOverride) {
            finalcards.forEach(c => c._historyUrlOverride = this.props.historyUrlOverride);
        }

        const exportURI = this.generateExportURI(columns, finalcards);

        return (
            <div>
                <ReactTable
                    filterable={true}
                    defaultFilterMethod={(filter, row) => {
                        if (row._nestingLevel > 0) return true;
                        if( String(row[filter.id]).toLowerCase().includes(String(filter.value).trim().toLowerCase()) )
                            return true;
                        // Now look at the subrows
                        if(row._subRows && row._subRows.length > 0)
                        {
                            for(var i = 0; i < row._subRows.length; i++)
                            {
                                if( String(row._subRows[i][filter.id]).toLowerCase().includes(String(filter.value).trim().toLowerCase()) )
                                    return true;
                                
                            }
                        }
                    }}
                    data = { finalcards }
                    columns = {columns}
                    noDataText={strings.reports_no_data_for_selected_time_period}
                    showPagination = {false}
                    defaultPageSize = {Number.MAX_SAFE_INTEGER} // RAV-1942, step one (effectively "set the page size to the number of rows" returned from the database)
                    minRows = {0} /* 0, do not show empty filler rows */
                    pivotBy = { pivots }
                    defaultSorted={[
                        ...sort,
                        { id: 'FactGeofenceState.startTime',
                          desc: false
                        }
                    ]}
                    getTrProps={(state, rowInfo, column) => {
                        if(rowInfo && rowInfo.aggregated)
                            return { className: '-rollup' };
                        return { className: '-padRow'};
                    }}
                />
                <div className='text-right mt-1'>
                    <a
                        className='btn btn-outline-blue btn-sm'
                        download="geofence-report.csv"
                        id="export-link"
                        href={exportURI}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {strings.action_export_CSV}
                    </a>
                </div>
            </div>
        );
    }
}

const ConnectedReportTable = connect()(ReportTable);

ReportsSection.propTypes = {
    selectedDateRange: PropTypes.instanceOf(Array).isRequired,
    showDrivingParking: PropTypes.oneOf(['trip', 'parked', 'both']).isRequired,
    unitOfMeasure: PropTypes.string.isRequired,
}

export default ReportsSection;
